/**
 * @deprecated
 */
export enum OpModeState {
	GREEN = "green",
	YELLOW = "yellow",
	RED = "red",
}
